import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/core/components/ui/badge";
import {
  REFERRAL_FIELD,
  REFERRAL_FIELD_TO_SORTER,
  REFFERRAL_STATUS_TO_SIDEBAR_TEXT,
  REFERRAL_STATUS_TO_BADGE_VARIANT,
} from "@/referrals/constants";
import { IReferral, ReferralStatus } from "@/referrals/referral";

const StatusCol = (): ColumnDef<IReferral> => ({
  header: "Status",
  accessorKey: "status",
  size: 120,
  minSize: 120,
  sortingFn: (a, b) =>
    REFERRAL_FIELD_TO_SORTER[REFERRAL_FIELD.status](a.original, b.original),
  cell: ({ getValue }) => {
    const status = getValue() as ReferralStatus;
    return (
      <Badge
        variant={
          REFERRAL_STATUS_TO_BADGE_VARIANT[
            status as keyof typeof REFERRAL_STATUS_TO_BADGE_VARIANT
          ]
        }
      >
        {REFFERRAL_STATUS_TO_SIDEBAR_TEXT[status]}
      </Badge>
    );
  },
});

export default StatusCol;
